<div class="top">
  <p class="top-word">
    <!-- 房源审核失败，请前往爱彼迎修改房源信息后重新提交审核 -->
    {{ "house.check_airbnb_house_failed" | translate }}
  </p>
</div>
<div class="container">
  <div
    class="house-list"
    *ngFor="let house of houseLists"
    (click)="chooseHouse(house)"
  >
    <div class="left">
      <img [src]="house?.cover_picture?.original_url" />
    </div>
    <div class="right">
      <p class="title" *ngIf="house?.house_title">{{ house?.house_title }}</p>
      <p class="title" *ngIf="!house?.house_title">
        <!-- 无 -->
        {{ "word.none" | translate }}
      </p>
      <div class="third-party">
        {{ "word.channel_0" | translate }}-{{ house?.username }}
      </div>
    </div>
  </div>
</div>
<div class="footer">
  <span>
    <!-- 共{{total}}个房源 -->
    {{
      (total > 1
        ? "house.channel_status.channel_houses_total"
        : "house.channel_status.channel_house_total"
      )
        | translate
          : {
              total: total
            }
    }}
  </span>
</div>
